import { React, useContext, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { Tooltip, Box, Typography, Card, CardContent,CardMedia  } from '@mui/material';
import {
  Business, LocalHospital, School, Store, Science,
  CardTravel, HomeWork, AttachMoney, AccountBalance,
  Gavel, Computer
} from '@mui/icons-material';
import { AuthContext } from '../context/AuthContext';
import { motion } from 'framer-motion';
import { Fade } from '@mui/material';
import LoadingScreen from './LoadingScreen';

const industries = [
  { label: 'Insurance', icon: <Business />, route: 'insurance', color: '#1976d2' },
  { label: 'Healthcare', icon: <LocalHospital />, route: 'healthcare', color: '#e53935' },
  { label: 'Education', icon: <School />, route: 'education', color: '#8e24aa' },
  { label: 'Small Industries', icon: <Store />, route: 'small-industries', color: '#f57c00' },
  { label: 'Research', icon: <Science />, route: 'research', color: '#43a047' },
  { label: 'Travel', icon: <CardTravel />, route: 'travel', color: '#00acc1' },
  { label: 'Real Estate', icon: <HomeWork />, route: 'real-estate', color: '#6d4c41' },
  { label: 'Finance', icon: <AttachMoney />, route: 'finance', color: '#2e7d32' },
  { label: 'Banking', icon: <AccountBalance />, route: 'banking', color: '#3949ab' },
  { label: 'Legal', icon: <Gavel />, route: 'legal', color: '#5e35b1' },
  { label: 'IT', icon: <Computer />, route: 'it', color: '#546e7a' },
];

// const accomplishments = [
//   "Built a successful startup in the IT industry",
//   "Led a team of 50+ developers",
//   "Received 'Innovator of the Year' award",
//   "Raised $5M in seed funding",
//   "Launched a global product that served 1M+ users",
//   "Built a successful startup in the IT industry",
//   "Led a team of 50+ developers",
//   "Received 'Innovator of the Year' award",
//   "Raised $5M in seed funding",
//   "Launched a global product that served 1M+ users",
// ];

const CircleHub = () => {
  const [isLoading, setIsLoading] = useState(true);
  
  const [isprovider] = useState(localStorage.getItem('isprovider'));
  const containerRef = useRef(null);
  const [size, setSize] = useState({ width: 300, height: 300 });
  const [leaders, setLeaders] = useState([]);
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 600;
  const centerX = size.width / 2;
  const centerY = size.height / 2;
  const radius = Math.min(size.width, size.height) / 2.5;
  const centerCircleRadius = Math.min(size.width, size.height) / 8;
  const { isAuthenticated,token } = useContext(AuthContext);
  const [isHovered, setIsHovered] = useState(false);
  
  const [accomplishments, setaccomplishments] = useState([]);
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const [openRequestDialog, setOpenRequestDialog] = useState(false);

  const [open, setOpen] = useState(false);
 const [dynamicData, setDynamicData] = useState({});
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      }
    });
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([getaccomplishmnet(),getdynamicdata()]);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);
  const getaccomplishmnet = async () => {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getaccomplishmnet`);
      setaccomplishments(res.data);
  };
  const getdynamicdata = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getdynamicdata`);
    const data = res.data.reduce((acc, { fieldname, fieldvalue }) => {
      acc[fieldname] = fieldvalue;
      return acc;
    }, {});
    setDynamicData(data);
  };

  useEffect(() => {
    const checkOpen = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/checkOpenRequests`, {
          headers: { Authorization: `Bearer ${token}` }
        });
  
        const hasOpenRequest = response.data?.hasOpenRequest;
  
        if (hasOpenRequest) {
          setOpenRequestDialog(true);
        }
      } catch (error) {
        console.error("Error checking open requests", error);
      }
    }; 
    if (isAuthenticated) {
      checkOpen(); 
    }
  }, [isAuthenticated, token]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getstackholder_list`)
      .then(res => {
        const data = res.data;
        setLeaders(data.leaders);
      })
      .catch(err => {
        console.error('Error fetching providers:', err);
      });
  }, []);
  useEffect(() => {
    if (isprovider === 'yes') {
      setOpen(true);
    }
  }, [isprovider]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleProceed = () => {
    setOpen(false);
    navigate('/opportunities');
  };
  return isLoading ? <LoadingScreen /> : (
    <Box sx={{ p: 2 }}>
      {/* Header */}
      <Typography variant="h4" align="center" sx={{ mt: 4, fontWeight: 'bold', color: '#1565c0' }}>
        Welcome to Udyog Connect
      </Typography>
      <Typography variant="subtitle1" align="center" sx={{ mb: 4, color: '#555' }}>
        Explore industries, connect with leaders, and collaborate for impact.
      </Typography>

      {/* Cards + Circle */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          flexWrap: 'wrap'
        }}
      >
        {/* Left Card */}
        <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
          <Card sx={{ width: { xs: '100%', sm: 250 }, boxShadow: 4 }}>
            <CardContent>
              <Typography variant="h6" fontWeight="bold">Community Stats</Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>👥 People Seeking Help: {dynamicData.seekinghelp || "25"}</Typography>
              <Typography variant="body1">❓Outstanding Questions: {dynamicData.outstandingquestions || "15"}</Typography>
            </CardContent>
          </Card>
        </motion.div>

        {/* Center: Radial Hub */}
        <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }}>
          <Box
            ref={containerRef}
            sx={{
              width: '100%',
              maxWidth: 600,
              height: { xs: 320, sm: 400, md: 500 },
              mx: 'auto'
            }}
          >
            <svg width="100%" height="100%" viewBox={`0 0 ${size.width} ${size.height}`} preserveAspectRatio="xMidYMid meet">
              <circle cx={centerX} cy={centerY} r={centerCircleRadius} fill="#0288d1" />
              <text x={centerX} y={centerY + 5} textAnchor="middle" fontSize="16" fill="white" fontWeight="bold">
                UDYOG
              </text>
              {!isAuthenticated && (
                <text
                  x={centerX}
                  y={centerY + 25}
                  textAnchor="middle"
                  fontSize="12"
                  fill="#e3f2fd"
                  style={{ cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={() => navigate('/login')}
                >
                  Click here to login
                </text>
              )}
              {industries.map((item, index) => {
                const angle = (2 * Math.PI * index) / industries.length;
                const outerX = centerX + radius * Math.cos(angle);
                const outerY = centerY + radius * Math.sin(angle);
                const lineStartX = centerX + centerCircleRadius * Math.cos(angle);
                const lineStartY = centerY + centerCircleRadius * Math.sin(angle);

                return (
                  <g key={index}>
                    <line x1={lineStartX} y1={lineStartY} x2={outerX} y2={outerY} stroke="#cfd8dc" strokeWidth="2" />
                    <Tooltip title={item.label} placement="top" arrow>
                      <circle
                        cx={outerX}
                        cy={outerY}
                        r={28}
                        fill={item.color}
                        onClick={() => navigate(`/industry/${item.route}`)}
                        style={{ cursor: 'pointer' }}
                      />
                    </Tooltip>
                    <foreignObject x={outerX - 16} y={outerY - 16} width={32} height={32}>
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {item.icon}
                      </Box>
                    </foreignObject>
                  </g>
                );
              })}
            </svg>
          </Box>
        </motion.div>

        {/* Right Card: Accomplishments with Waterfall Animation */}
        <motion.div initial={{ opacity: 0, x: 100 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
          <Card sx={{ width: { xs: '100%', sm: 250 }, boxShadow: 4 }}>
            <CardContent>
              <Typography variant="h6" fontWeight="bold">Accomplishments</Typography>
              <Box sx={{ mt: 2 }}>
                {accomplishments.map((accomplishment, idx) => (
                  <motion.div
                    key={idx}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.2, duration: 0.5 }}
                  >
                    <Typography variant="body1">✅ {accomplishment.description}</Typography>
                  </motion.div>
                ))}
              </Box>
            </CardContent>
          </Card>
        </motion.div>
      </Box>

      {/* Industry Leaders moved to bottom */}
      <Box sx={{ mt: 6 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
          Our Founders
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
          {leaders.map((leader, idx) => (
            <motion.div key={idx} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: idx * 0.1 }}>
              <Card sx={{
                      display: 'flex',
                      width: 300,
                      height: 100,
                      alignItems: 'center',
                      boxShadow: 2,
                      borderRadius: 2,
                      overflow: 'hidden',
                    }}>
                <CardMedia
                  component="img"
                  image={leader.img}
                  alt={leader.name}
                  sx={{
                    width: 100,
                    height: 100,
                    objectFit: 'contain',
                    backgroundColor: '#f4f4f4',
                    borderRadius: '8px 0 0 8px',
                    flexShrink: 0
                  }}
                />

                 <Box sx={{ p: 2 }}>
                  <Typography fontWeight="bold">{leader.name}</Typography>
                  <Typography variant="body2" color="text.secondary">{leader.title}</Typography>
                </Box>
              </Card>
            </motion.div>
          ))}
        </Box>
      </Box>
      <Dialog
        open={openRequestDialog}
        onClose={() => setOpenRequestDialog(false)}
        fullWidth
        maxWidth="xs"
        TransitionComponent={Fade}
        PaperProps={{
          sx: { borderRadius: 4, p: 2, textAlign: 'center' }
        }}
      >
        <DialogTitle>
          🚨 You have an open request!
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
            Please complete or close your current request before creating a new one.
          </Typography>
          <Box display="flex" justifyContent="space-around" mt={2}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOpenRequestDialog(false)}
            >
              Skip
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setOpenRequestDialog(false);
                navigate('/request');
              }}
            >
              Proceed
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      
      <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Fade}
      keepMounted
      fullWidth
      maxWidth="xs"
      PaperProps={{
        style: {
          borderRadius: 20,
          padding: '20px',
          textAlign: 'center',
        }
      }}
    >
      <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
        🚀 Got Opportunities?
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mt: 1 }}>
          We noticed you're a provider. Do you think there are open opportunities you'd like to add?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, mt: 2 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="secondary"
          sx={{ minWidth: 100, borderRadius: '20px' }}
        >
          Skip
        </Button>
        <Button
          onClick={handleProceed}
          variant="contained"
          color="primary"
          sx={{ minWidth: 100, borderRadius: '20px' }}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>

    </Box>
  );
};

export default CircleHub;
